import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import VueClipboard from 'vue-clipboard2'

import { initI18n } from '@xpeng/i18n'
import { messages } from './config/i18n'
// import Icon from 'vue-svg-icon/Icon.vue'
import Icon from './vendor/svg-icon/Icon.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import ZkTable from 'vue-table-with-tree-grid'

import XpSearchbar from '@xpeng/searchbar'
import XpTable from '@xpeng/table'

import XpDialog from '@xpeng/dialog'

import * as filters from './filters'

// 指令
import AutoTableHeader from '@xpeng/v-auto-table-header'

Vue.use(ElementUI)
Vue.use(XpTable)
Vue.use(AutoTableHeader)
Vue.use(VueClipboard)

const components = {
  XpSearchbar,
  XpDialog,
  icon: Icon,
  TreeTable: ZkTable
}
for (let [name, component] of Object.entries(components)) {
  Vue.component(name, component)
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.config.devtools = true

// 这是一个hack, 根源在于原来xiaopeng的auth-sdk中的domain是可以浏览器和容器两侧访问的,而cea不行.
// 所以一开始制造了很多domain的麻烦
// 这个链路是从sdk到接口返回的, 实际上接口根本不需要给出domainPrefix,只要path后缀就可以了,
// domain就是当前页面的domain, 让前端适配
window.locationDirect = url => {
  url = String(url)
  console.warn('----locationDirect:', url)
  // 相对路径
  if (!url.startsWith('http')) {
    return (location.href = url)
  }
  // 跳转其他域名
  if (!url.includes(window.location.host)) {
    console.warn('external redirect', url)
  }

  // 把local遗留问题换为当前域名  local问题已清理
  // cn不跳local
  if (window.location.hostname.includes('.cn') && url.includes('.local')) {
    url = url.replace('.local', '.cn')
  }
  // local不跳cn
  else if (window.location.hostname.includes('.local') && url.includes('.cn')) {
    url = url.replace('.cn', '.local')
  }

  // lgn.
  if (url.match(/^https?:\/\/lgn\./i)) {
    console.log('it is lgn url')
    url = url.replace(/https?:\/\/[^/]+/, 'https://' + window.location.host) // lgn替换为e-portal
    // url = url.replace(/https?:\/\/[^/]+/,'https://'+window.location.host.replace('e.','lgn.'));
  }
  // e.
  else if (url.match(/^https?:\/\/e\./i)) {
    console.log('it is e url')
    url = url.replace(/https?:\/\/[^/]+/, 'https://' + window.location.host) // e替换为e-portal
  }
  // biz....
  else {
    console.log(url)
  }
  console.warn(url)
  // debugger;
  window.location.href = url
}
const bootstrap = async () => {
  const i18n = await initI18n(messages)
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
bootstrap()
